import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconProfileComponent } from "./med-icon-profile.component";

@NgModule({
  declarations: [
    MedIconProfileComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconProfileComponent,
  ],
})
export class MedIconProfileModule { }
